import { Injectable } from '@angular/core';
import { BaseService } from '../../../../../../shared/src/lib/services/base.service';
import { EUserType, ISaveUser, IUser } from '../../../../../../shared/src/lib/@ngrx/user/user.model';
import { ISR } from '../../../../../../shared/src/lib/models/index.model';
import { environment } from '../../../../../../shared/src/environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService<U = IUser, SU extends { id?: number } = ISaveUser> extends BaseService {
  protected override baseURL = `v1/users/`;
  constructor() {
    super();
  }

  fetchAll(query?: { userGroup?: string; userName?: string; company?: string }) {
    return this.get<ISR<U>>(`search`, query);
  }

  searchUsers(query?: any) {
    return this.get<ISR<U>>(`search`, query).pipe(map((r) => r.content));
  }

  create(data: SU) {
    return this.post<U>(data, 'signup');
  }

  update(data: SU) {
    return this.put<U>(data, data.id! + '');
  }

  resetPassword = (username: string, userType: 'admin' | 'candidate' | 'partner') =>
    this.apiS.get(`v1/authentication/recover-credentials`, {
      username,
      loginUrl:
        userType == 'admin'
          ? environment.adminURL
          : userType == 'partner'
            ? environment.partnerURL
            : userType == 'candidate'
              ? environment.candidateURL
              : '',
    });
}
